import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  applicationsPage: {
    width: "96%",
    height: "100%",
    [theme.breakpoints.down('md')]: {
      width: "100%",
      paddingBottom: 48,
    },
    "& .child-row-styles": {
      backgroundColor: "#f7f9ff",
    },
    "& .parent-row:hover": {
      cursor: "pointer",
    },
  },
  pageHeader: {
    // display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "& h1": {
      fontSize: 20,
      fontWeight: 600,
      margin: "8px 0",
    },
    [theme.breakpoints.down('md')]: {
      display: "block",
    },
  },
  headerTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& .MuiButton-root": {
      fontSize: 16,
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },
    "& .MuiButton-textPrimary:hover ": {
      backgroundColor: "white",
    },
    "& .MuiTouchRipple-root": {
      display: "none",
    },
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",

    "&.MuiFormGroup-root": {
      display: "flex",
      flexDirection: "row !important",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  applicationsTable: {
    "& .MuiDataGrid-main": {
      fontFamily: "Montserrat",
      fontWeight: "bold",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#E5EBFF",
    },
    "& a": {
      color: "inherit",
      width: "100%",
      textAlign: "center",
    },
  },
  statusSelector: {
    boxSizing: "border-box",
    height: 124,
    width: 200,
    border: "1px solid #eef0f7",
    borderRadius: 8,
    // `cornerGlow` variant from the Gradient Lab: white card with a subtle
    // blue radial glow in the top-right corner.
    background:
      "radial-gradient(at 100% 0%, rgba(0, 51, 255, 0.18) 0%, transparent 70%), #fff",
    padding: 28,
    cursor: "pointer",
    marginRight: 15,
    color: "#000c3b",
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      flexShrink: 0,
    },
  },
  amount: {
    fontWeight: 700,
    fontSize: 40,
    lineHeight: 1,
    color: "#000c3b",
  },
  statusAmount: {
    display: "block",
    marginTop: 8,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#4a5280",
  },
  amountsWrapper: {
    display: "flex",
    paddingBottom: 20,
    borderBottom: "1px solid #DADFF6",
    [theme.breakpoints.down('sm')]: {
      justifyContent: "flex-start",
      flexWrap: "nowrap",
      gap: 8,
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
      // Break out of the AdminLayout `.content` 16px side padding so the
      // scroll strip runs viewport-edge to viewport-edge. Inner padding
      // preserves the original visual inset for the first/last card while
      // letting cards scroll flush with the screen edge.
      marginLeft: -16,
      marginRight: -16,
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  active: {
    borderWidth: 2,
    borderColor: ({ activeStatus }: any) =>
      activeStatus === "New"
        ? "#2eb662"
        : activeStatus === "In progress"
        ? "blue"
        : activeStatus === "Pending"
        ? "#ffb20d"
        : activeStatus === "Closed"
        ? "#757fa4"
        : "",
  },
  selectField: {
    width: 220,
    [theme.breakpoints.down('sm')]: {
      width: "100%",
    },
  },
  selectWrapper: {
    // display: "flex",
    margin: "20px 0",
    "& :nth-of-type(2)": {
      marginLeft: "20px",
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        marginTop: 10,
        width: "100%",
      },
    },
    "& > *:last-child": {
      width: 300,
      marginLeft: "20px",
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        marginTop: 10,
        width: "100%",
      },
    },
  },
  // Mobile-only: collapses the filter select row. We keep it in the DOM
  // (vs unmounting) so the aria-controls relationship from the Filters
  // button stays valid and component state is preserved across toggles.
  selectWrapperHidden: {
    display: "none",
  },
  // Wrapper around the mobile Filters toggle button. Adds breathing room
  // between the status cards above and the filter panel below, and keeps
  // the Badge's offset-count from clipping the status row.
  filterToggleWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "16px 0 12px",
    [theme.breakpoints.up('md')]: {
      display: "none",
    },
  },
  toggle: {
    display: "flex",
    paddingLeft: 10,
    alignItems: "center",
    "& .MuiSvgIcon-root": {
      verticalAlign: "bottom",
      marginLeft: 10,
      cursor: "pointer",
    },
  },
}));
